import AddressBadging from './AddressBadging';

export default AddressBadging;
